import { render, staticRenderFns } from "./ConferenciaBaseDialog.vue?vue&type=template&id=d61b28aa"
import script from "./ConferenciaBaseDialog.vue?vue&type=script&lang=js"
export * from "./ConferenciaBaseDialog.vue?vue&type=script&lang=js"
import style0 from "./ConferenciaBaseDialog.vue?vue&type=style&index=0&id=d61b28aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports